export default __webpack_public_path__ + "static/media/Consultation.b711d2c3.png";